import { useLayoutPartialsContext } from "@circle-react/contexts/layoutPartialsContext";

export const BrowserNotificationPrompt = () => {
  const { data: { browser_notifications_html } = {} } =
    useLayoutPartialsContext();
  return (
    <div dangerouslySetInnerHTML={{ __html: browser_notifications_html }} />
  );
};
